import { createClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase único da aplicação.
 * Usa SOMENTE a anon key (pública, protegida por RLS). A service key nunca entra no front.
 * As variáveis vêm do .env (dev) ou das env vars do Cloudflare Pages (produção).
 */
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Falha cedo e visível: sem credenciais o app não funciona.
  console.error('[AcessaHUOL] Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env');
}

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});
